import gql from "graphql-tag";

export const CREATE_REFERRAL = gql`
  mutation createReferral($input: CreateReferralInput!) {
    createReferral(input: $input) {
      id
      referralUuid
    }
  }
`;

export const SEARCH_EXTERNAL_PROVIDERS = gql`
  query searchExternalProviders($searchText: String, $externalOrganizationId: Int) {
    searchExternalProviders(searchText: $searchText, externalOrganizationId: $externalOrganizationId) {
      id
      contact {
        firstName
        lastName
        fullName
      }
      externalOrganization {
        id
      }
    }
  }
`;
